export function useNotification() {
  const { $toast } = useNuxtApp();
  const { t } = useI18n();

  const showSuccess = (message, title = null) => {
    if (message) {
      $toast({
        message: message || t('generic.success'),
        title: title || t('generic.success'),
        type: 'success',
      });
    }
  };

  const showError = (message, title = null) => {
    if (message) {
      $toast({
        message: message || t('generic.error'),
        title: title || t('generic.error'),
        type: 'danger',
      });
    }
  };

  const showWarning = (message, title = null) => {
    if (message) {
      $toast({
        message: message || t('generic.warning'),
        title: title || t('generic.warning'),
        type: 'warning',
      });
    }
  };

  const showInfo = (message, title = null) => {
    if (message) {
      $toast({
        message: message || t('generic.info'),
        title: title || t('generic.info'),
        type: 'info',
      });
    }
  };

  return {
    showSuccess,
    showWarning,
    showError,
    showInfo,
  };
}
